var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{attrs:{"event":_vm.event,"eventId":_vm.$route.params.id,"getBuy":_vm.getBuy},on:{"checkDuplicate":_vm.checkDuplicate}}),_c('event-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }